import React from 'react';
import { ConsultationForm } from './ConsultationForm';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
export function FinalContact() {
  return <section id="contact" className="section-padding bg-white border-t border-steel" data-id="element-174">
      <div className="container-custom" data-id="element-175">
        <div className="grid lg:grid-cols-12 gap-16 items-start" data-id="element-176">
          <div className="lg:col-span-5" data-id="element-177">
            <h2 className="text-3xl md:text-5xl font-black text-navy mb-6 leading-tight tracking-tight" data-id="element-178">
              Talk to FSG About Dispatch
            </h2>
            <p className="text-lg text-body font-medium mb-10 leading-relaxed" data-id="element-179">
              Tell FSG what is slowing you down — loads, paperwork, brokers,
              billing, or dispatch — and a U.S.-based team member will help
              point you in the right direction.
            </p>

            <div className="bg-navy text-white border border-navy p-8 rounded-sm shadow-xl space-y-6 relative overflow-hidden" data-id="element-180">
              <div className="absolute top-0 left-0 w-full h-1 bg-red" data-id="element-181" />
              <h3 className="text-xs font-bold uppercase tracking-widest text-off-white/50" data-id="element-182">
                Direct Contact
              </h3>
              <a href="tel:2346028424" className="flex items-center gap-4 text-white hover:text-red transition-colors group" data-id="element-183">
                <div className="w-12 h-12 bg-white/5 border border-white/10 rounded-sm flex items-center justify-center group-hover:border-red/30 group-hover:bg-red/10 transition-colors" data-id="element-184">
                  <Phone className="w-5 h-5" data-id="element-185" />
                </div>
                <span className="font-bold text-xl tracking-wide" data-id="element-186">
                  234-602-8424
                </span>
              </a>
              <a href="mailto:Dispatch@FSGTransport.com" className="flex items-center gap-4 text-white hover:text-red transition-colors group" data-id="element-187">
                <div className="w-12 h-12 bg-white/5 border border-white/10 rounded-sm flex items-center justify-center group-hover:border-red/30 group-hover:bg-red/10 transition-colors" data-id="element-188">
                  <Mail className="w-5 h-5" data-id="element-189" />
                </div>
                <span className="font-bold text-lg" data-id="element-190">
                  Dispatch@FSGTransport.com
                </span>
              </a>
              <div className="flex items-center gap-4 text-white" data-id="element-191">
                <div className="w-12 h-12 bg-white/5 border border-white/10 rounded-sm flex items-center justify-center" data-id="element-192">
                  <MapPin className="w-5 h-5 text-white/50" data-id="element-193" />
                </div>
                <span className="font-bold text-lg" data-id="element-194">
                  P.O. Box 366, Hudson, OH 44236
                </span>
              </div>
              <div className="flex items-center gap-4 text-white" data-id="element-195">
                <div className="w-12 h-12 bg-white/5 border border-white/10 rounded-sm flex items-center justify-center" data-id="element-196">
                  <Clock className="w-5 h-5 text-white/50" data-id="element-197" />
                </div>
                <span className="font-bold text-lg" data-id="element-198">
                  Sales Hours: Mon–Fri, 9:00 AM–5:00 PM EST
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-199">
            <div className="bg-white border-2 border-steel p-8 md:p-12 rounded-sm shadow-2xl relative" data-id="element-200">
              <div className="absolute -top-4 left-8 bg-navy text-white px-4 py-1 text-xs font-bold uppercase tracking-widest rounded-sm" data-id="element-201">
                Sign Up / Contact
              </div>
              <ConsultationForm data-id="element-202" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}